var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonieAvatarC3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.166.03h19.849v30.56H.166z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.037.131H12.3v13.8H.037z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.18 11.905c.093 3.521.736 7.236 2.982 9.399 1.828 1.759 6.046 2.467 10.144 2.432 4.678-.042 8.113-.65 10.075-2.263 2.327-1.913 2.879-6.02 3.048-9.516.19-3.947-.375-7.124-2.532-9.295C21.539.288 16.243.206 13.164.167a27.18 27.18 0 00-.287-.001c-2.734 0-7.72.46-9.911 2.134C.434 4.234.1 8.876.18 11.905z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M.18 11.905c.093 3.521.736 7.236 2.982 9.399 1.828 1.759 6.046 2.467 10.144 2.432 4.678-.042 8.113-.65 10.075-2.263 2.327-1.913 2.879-6.02 3.048-9.516.19-3.947-.375-7.124-2.532-9.295C21.539.288 16.243.206 13.164.167a27.18 27.18 0 00-.287-.001c-2.734 0-7.72.46-9.911 2.134C.434 4.234.1 8.876.18 11.905z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 28,
    cy: 28,
    r: 28
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AF192D",
    d: "M20.107 47.242c-.333.338-.645.698-1.068 1.448-1.453 2.58-3.134 7.362-4.057 11.043-1.224 4.883-1.275 11.626 1.8 10.768 1.867-.52-.476-3.129.076-3.383.48-.22 1.248 1.613 2.138.784.953-.888-.707-1.846-1.147-2.527-.384-.596-.51-1.159-.443-2.241.128-2.067.887-5.232 2.087-8.33 1.181-3.053 2.331-4.645 2.331-4.645l1.554-2.838-3.27-.079zM37.038 47.378c.28.33.68.871.987 1.418 1.583 2.822 3.08 7.398 4.019 11.054 1.246 4.85 1.42 11.29-1.645 10.453-1.86-.507.456-3.114-.095-3.364-.479-.217-1.232 1.612-2.122.792-.953-.878.693-1.84 1.126-2.52.38-.595.5-1.155.428-2.231-.14-2.055-1.041-5.152-2.124-8.272-.912-2.63-2.515-4.85-2.515-4.85l-1.233-2.542 3.174.062z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.47 47.455)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DC2828",
    d: "M4.175.03C3.408 2.91 1.55 9.975.963 15.301.037 23.7.068 29.317.313 29.681c.383.57 1.955.908 3.986.908 1.914 0 4.178-.497 4.487-.932.308-.435-.172-3.548.2-3.984.37-.436 1.869-.454 2.172.037.315.508-.183 3.53.086 4.004.257.452 2.49.875 4.688.875 1.844 0 3.602-.282 3.924-.908.283-.55.244-5.996-.59-14.139-.542-5.28-2.357-12.316-3.146-15.196L4.175.03z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AC212E",
    d: "M30.42 75.03s1.632-.848 4.154-.848c2.482 0 3.734.528 3.734.528l.01-.204s-1.68-.536-3.744-.536c-2.434 0-4.153.83-4.153.83v.23zM26.58 75.03s-1.632-.848-4.154-.848c-2.482 0-3.734.528-3.734.528l-.01-.204s1.68-.536 3.744-.536c2.434 0 4.153.83 4.153.83v.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF192D",
    d: "M12.92 21.576c.35-3.387.86-10.474 2.267-10.605 1.078-.1 4.955 4.958 7.124 7.517l-9.39 3.088z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.341 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AA141E",
    d: "M12.041 13.932c.183-3.586.714-13.343-.627-13.766C9.512-.434 3.206 6.87.037 10.134l12.004 3.798z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DC2828",
    d: "M29.814 17.758c4.044 0 11.864.791 14.747 3.996 2.82 3.137 1.17 19.68-2.13 22.892-3.056 2.974-6.794 3.445-12.617 3.445-5.747 0-12.708-.27-16.23-4.176-3.243-3.6-3.201-19.967-1.16-22.316 3.177-3.659 12.521-3.841 17.39-3.841"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDA075",
    d: "M28.346 22.638c3.099.038 8.429.122 10.802 2.514 2.172 2.188 2.74 5.39 2.549 9.369-.17 3.523-.726 7.663-3.068 9.59-1.974 1.626-5.431 2.24-10.14 2.282-4.124.036-8.37-.678-10.209-2.451-2.26-2.18-2.907-5.924-3.001-9.474-.08-3.052.255-7.732 2.803-9.681 2.285-1.747 7.59-2.182 10.264-2.149"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.268 22.424)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.283 4.204c3.66 1.215 8.533.84 8.533.84s-1.23-.347-2.246-.817c-1.145-.53-1.712-1.056-1.712-1.056s.887.38 2.026.546c1.213.177 2.856.013 2.856.013s-.287-2.303-5.308-3.281C14.335-.545 8.977.409 8.977.409s2.62 2.57 6.306 3.795z",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.268 22.424)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.727 2.555a10.84 10.84 0 001.177 2.078S8.55 4.25 7.39 3.337C6.179 2.384 5.71.886 5.71.886S6.196.764 6.935.61C7.675.458 8.262.367 8.262.367s-.027 1.018.465 2.188z",
    mask: "url(#j)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.18 40.435s.909 1.13 2.818 1.32c1.888.188 3.026-.348 3.026-.348l.025.399s-1.5.488-3.142.275c-2.018-.262-2.992-1.387-2.992-1.387l.264-.259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M20.532 28.878c-1.592 0-3.227 1.54-3.227 4.514 0 3.304 1.994 4.535 3.124 4.535 1.52 0 3.411-1.067 3.411-4.555 0-2.975-1.705-4.494-3.308-4.494"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#774D28",
    d: "M20.49 31.32c.864 0 1.686.8 1.686 2.216 0 1.518-.987 1.949-1.686 1.949-.74 0-1.5-.8-1.5-2.051 0-.985.658-2.114 1.5-2.114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.532 32.366c.883 0 1.11 2.073-.062 2.073-.925 0-.76-2.073.062-2.073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M35.384 28.878c-1.592 0-3.227 1.54-3.227 4.514 0 3.304 1.994 4.535 3.124 4.535 1.52 0 3.411-1.067 3.411-4.555 0-2.975-1.705-4.494-3.308-4.494"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#774D28",
    d: "M35.343 31.32c.863 0 1.685.8 1.685 2.216 0 1.518-.986 1.949-1.685 1.949-.74 0-1.5-.8-1.5-2.051 0-.985.657-2.114 1.5-2.114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.384 32.366c.884 0 1.11 2.073-.062 2.073-.925 0-.76-2.073.062-2.073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAB898",
    d: "M28.858 35.36c-.232-.293-1.062-.446-1.535-.112-.9.635-.685 2.187-.685 2.187h2.728s.059-1.358-.508-2.075"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A98561",
    d: "M27.233 38.774c-.471-.367-.595-1.328-.595-1.328l2.713-.012s-.17 1.065-.601 1.342c-.356.228-1.2.244-1.517-.002z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonieAvatarC3);
export default __webpack_public_path__ + "static/media/tonieAvatar-c3.ae51111cd5e5357561d0f256fd958786.svg";
export { ForwardRef as ReactComponent };